import { Locale } from 'config/constants/locales';
import { useRegion } from 'hooks/use-region';
import { RegionConfig, getCanonicalConfig, getRegionConfig } from './index';

const useConfig = (): RegionConfig => {
  const region = useRegion();

  return getRegionConfig(region);
};

const useCanonicalConfig = (locale?: Locale): RegionConfig => {
  const region = useRegion();

  return getCanonicalConfig(region, locale);
};

export { useCanonicalConfig, useConfig };
